// extracted by mini-css-extract-plugin
module.exports = {"tabListItem":"Tab_tabListItem__28HgE","tabListActive":"Tab_tabListActive__3vfih"};